
import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'trader' | 'firm' | 'admin';
  redirectTo?: string;
}

const ProtectedRoute = ({ 
  children, 
  requiredRole,
  redirectTo = '/auth' 
}: ProtectedRouteProps) => {
  const { user, userRole, isLoading } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log('ProtectedRoute check:', {
      user: !!user,
      userRole: userRole?.role,
      requiredRole,
      isLoading,
      path: location.pathname
    });
  }, [user, userRole, requiredRole, isLoading, location.pathname]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-dark-bg flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-electric-blue"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (requiredRole && userRole?.role !== requiredRole) {
    // Redirect to appropriate dashboard based on user's actual role
    const roleRedirects = {
      trader: '/dashboard',
      firm: '/firm-panel',
      admin: '/sys-x9k2m-panel-7q4w/admin'
    };
    
    const redirectPath = userRole?.role ? roleRedirects[userRole.role] : '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
